import { Http, Response } from '@angular/http';
import { Router, ActivatedRoute } from '@angular/router';
import { AlertService } from '../services/index';
import { JWT } from '../helpers';
import { LOGINENDPOINTS } from '../environment';
var LoginService = /** @class */ (function () {
    function LoginService(http, route, router, alertService) {
        this.http = http;
        this.route = route;
        this.router = router;
        this.alertService = alertService;
        this.apiurl = '';
        this.apiurl = process.env.API_URL;
        console.log(this.apiurl);
    }
    LoginService.prototype.signup = function (user) {
        //http://dev.uvsity.com
        console.log(user);
        return this.http.post(this.apiurl + LOGINENDPOINTS.signup, user, JWT.signupJwt()).map(function (response) { return response.json(); });
    };
    LoginService.prototype.resetPassword = function (pass) {
        //http://dev.uvsity.com
        console.log(pass);
        return this.http.post(this.apiurl + LOGINENDPOINTS.resetPassword, pass, JWT.signupJwt()).map(function (response) { return response.json(); });
    };
    LoginService.prototype.country = function () {
        //http://dev.uvsity.com
        return this.http.get(this.apiurl + LOGINENDPOINTS.country, JWT.jwt()).map(function (response) { return response.json(); });
    };
    LoginService.prototype.userCountry = function () {
        return this.http.get('https://api.ipdata.co?api-key=7f8d8e0c0be76a27c8d30fe0d9034ae60b057c4c6e6b912f0531c3fb').map(function (response) { return response.json(); });
        //return this.http.get(this.apiurl + LOGINENDPOINTS.ipData).map((response: Response) => response.json());
    };
    LoginService.prototype.location = function () {
        return this.http.get(this.apiurl + LOGINENDPOINTS.location).map(function (response) { return response.json(); });
    };
    LoginService.prototype.state = function (countryid) {
        //http://dev.uvsity.com
        return this.http.get(this.apiurl + LOGINENDPOINTS.state + countryid, JWT.jwt()).map(function (response) { return response.json(); });
    };
    LoginService.prototype.filterState = function (countryid, queryState) {
        //http://dev.uvsity.com
        return this.http.get(this.apiurl + LOGINENDPOINTS.filterState + countryid + '?queryState=' + queryState, JWT.jwt()).map(function (response) { return response.json(); });
    };
    LoginService.prototype.city = function (stateid) {
        //http://dev.uvsity.com
        console.log(stateid);
        return this.http.get(this.apiurl + LOGINENDPOINTS.city + stateid, JWT.jwt()).map(function (response) { return response.json(); });
    };
    LoginService.prototype.filterCity = function (stateid, queryCity) {
        //http://dev.uvsity.com
        console.log(stateid);
        return this.http.get(this.apiurl + LOGINENDPOINTS.filterCity + stateid + '?queryCity=' + queryCity, JWT.jwt()).map(function (response) { return response.json(); });
    };
    LoginService.prototype.usertype = function () {
        //http://dev.uvsity.com
        return this.http.get(this.apiurl + LOGINENDPOINTS.usertype, JWT.jwt()).map(function (response) { return response.json(); });
    };
    LoginService.prototype.filterUsertype = function (queryUsertype) {
        //http://dev.uvsity.com
        return this.http.get(this.apiurl + LOGINENDPOINTS.filterUsertype + '?queryUsertype=' + queryUsertype, JWT.jwt()).map(function (response) { return response.json(); });
    };
    LoginService.prototype.eduins = function () {
        //http://dev.uvsity.com
        return this.http.get(this.apiurl + LOGINENDPOINTS.eduins, JWT.jwt()).map(function (response) { return response.json(); });
    };
    LoginService.prototype.filterEduins = function (queryEduins) {
        //http://dev.uvsity.com
        return this.http.get(this.apiurl + LOGINENDPOINTS.filterEduins + '?queryEduins=' + queryEduins, JWT.jwt()).map(function (response) { return response.json(); });
    };
    LoginService.prototype.signup2 = function (user) {
        //http://dev.uvsity.com
        console.log(user);
        return this.http.post(this.apiurl + LOGINENDPOINTS.signup2, user, JWT.jwt()).map(function (response) { return response.json(); });
    };
    LoginService.prototype.secondaryData = function (user) {
        console.log(user);
        return this.http.post(this.apiurl + LOGINENDPOINTS.secondaryData, user, JWT.jwt()).map(function (response) { return response.json(); });
    };
    LoginService.prototype.login = function (username, password) {
        console.log(this.apiurl);
        return this.http.get(this.apiurl + LOGINENDPOINTS.login + '?emailId=' + username + '&password=' + password, {})
            .map(function (response) { return response; });
    };
    LoginService.prototype.loginByGoogle = function (token, userRegistrationTimezone, userLoggedInIPAddress) {
        console.log(this.apiurl);
        console.log('token', token);
        return this.http.post(this.apiurl + LOGINENDPOINTS.loginByGoogle + '?googleIdToken=' + token
            + "&userRegistrationTimezone=" + userRegistrationTimezone
            + "&userLoggedInIPAddress=" + userLoggedInIPAddress, {}, JWT.signupJwt())
            .map(function (response) { return response; });
    };
    LoginService.prototype.forgotPasswordOrResendEmail = function (username, forgotPasswordRecaptchaToken) {
        console.log(this.apiurl);
        return this.http.get(this.apiurl + LOGINENDPOINTS.forgotPasswordOrResendEmail + '?emailId=' + username +
            '&forgotPasswordRecaptchaToken=' + forgotPasswordRecaptchaToken, {})
            .map(function (response) { return response; });
    };
    LoginService.prototype.resendEmailPublic = function (username, resendemailRecaptchaToken) {
        console.log(this.apiurl);
        return this.http.post(this.apiurl + LOGINENDPOINTS.resendEmailPublic + '?emailId=' + username + '&resendemailRecaptchaToken='
            + resendemailRecaptchaToken, {}, JWT.signupJwt())
            .map(function (response) { return response; });
    };
    LoginService.prototype.topcourse = function () {
        return this.http.get(this.apiurl + LOGINENDPOINTS.topcourse, JWT.signupJwt()).map(function (response) { return response.json(); });
    };
    LoginService.prototype.courseNameAutocomplate = function (word) {
        return this.http.post(this.apiurl + LOGINENDPOINTS.courseNameAutocomplate + word + '/', {}, JWT.signupJwt()).map(function (response) { return response.json(); });
    };
    LoginService.prototype.openCourses = function () {
        return this.http.post(this.apiurl + LOGINENDPOINTS.openCourses, {}, JWT.signupJwt()).map(function (response) { return response.json(); });
    };
    LoginService.prototype.searchCourse = function (data) {
        return this.http.post(this.apiurl + LOGINENDPOINTS.searchCourse, data, JWT.signupJwt()).map(function (response) { return response.json(); });
    };
    LoginService.prototype.courseownerNameAutocomplate = function (word) {
        return this.http.post(this.apiurl + LOGINENDPOINTS.courseownerNameAutocomplate + word + '/', {}, JWT.signupJwt()).map(function (response) { return response.json(); });
    };
    LoginService.prototype.openCoursesFilters = function () {
        return this.http.get(this.apiurl + LOGINENDPOINTS.openCoursesFilters, JWT.signupJwt()).map(function (response) { return response.json(); });
    };
    LoginService.prototype.getCourse = function (id) {
        return this.http.get(this.apiurl + LOGINENDPOINTS.getCourse + id + '/', JWT.signupJwt()).map(function (response) { return response.json(); });
    };
    LoginService.prototype.getTopic = function (id) {
        return this.http.get(this.apiurl + LOGINENDPOINTS.getTopic + id + '?isTopicSubscriberOnly=false', JWT.signupJwt()).map(function (response) { return response.json(); });
    };
    LoginService.prototype.resendEamil = function (email) {
        return this.http.post(this.apiurl + LOGINENDPOINTS.resendEamil + email, {}, JWT.signupJwt()).map(function (response) { return response.json(); });
    };
    LoginService.prototype.searchUser = function (User) {
        return this.http.post(this.apiurl + LOGINENDPOINTS.searchUser, User, JWT.jwt()).map(function (response) { return response.json(); });
    };
    LoginService.prototype.generateOtp = function (data) {
        return this.http.post(this.apiurl + LOGINENDPOINTS.generateOtp + "?emailId=" + data.emailId, {}, JWT.signupJwt()).map(function (response) { return response.toString(); });
    };
    LoginService.prototype.submitOtp = function (data) {
        return this.http.post(this.apiurl + LOGINENDPOINTS.submitOtp + "?emailId=" + data.emailId + "&otp=" + data.otp, {}, JWT.signupJwt()).map(function (response) { return response.toString(); });
    };
    return LoginService;
}());
export { LoginService };
//# sourceMappingURL=login.service.js.map